import React from 'react'
import { connect } from 'react-redux'
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined'

import { getIsPaused } from '../selectors'
import './PausedBanner.css'

type PausedBannerProps = {
  isPaused: boolean
}

const PAUSED_MESSAGE =
  'Your enrollment is paused and shopping is temporarily unavailable. This does not impact your existing benefits.'

/**
 * Banner shown below the header (in the content flow, above the page) while the employee's
 * enrollment is paused. Visually mirrors the shared TopBannerAlert (provider-outage) info alert.
 *
 * Connected to the RAW `getIsPaused` flag (not the per-actor one) so an impersonated admin / test
 * user still sees the paused state for context even though they are exempt from the shopping block.
 */
export const PausedBanner = ({ isPaused }: PausedBannerProps) => {
  if (!isPaused) return null
  return (
    <div data-testid="paused-banner" className="paused-banner" role="status">
      <div className="paused-banner__content">
        <InfoCircleOutlined className="paused-banner__icon" />
        <span className="paused-banner__body">{PAUSED_MESSAGE}</span>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  isPaused: getIsPaused(state),
})

export default connect(mapStateToProps)(PausedBanner)
